import React from 'react';
import FormTextInput from './FormTextInput';

const FormLongTextInput = (props) => (
    <FormTextInput multiline rows={14} {...props} />
);

export default FormLongTextInput;
